// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import Share from 'components/Share/Share'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Search from 'components/Search/Search'
import SearchResults from 'components/Search/SearchResults'
import { getScrollbarWidth } from 'utilities/scrollbar'
import LocaleSelect from './LocaleSelect'

// Redux:
import { closeMenu, getMenuData } from 'actions/site'
import { getPageData } from 'actions/page'
import {
	openSearch,
	setAllowMapOverride,
	getSearchData,
	searchAction
} from 'actions/search'

class Menu extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			itemText: false
		}
	}

	componentDidMount() {
		this.scrollbarWidth = getScrollbarWidth()
	}

	componentDidUpdate( prevProps, prevState ) {
		const { locale, getMenuData, menuIsOpen } = this.props

		if ( locale != prevProps.locale ) {
			getMenuData()
		}

		if ( menuIsOpen ) {
			document.documentElement.classList.add( 'with-site-menu-open' )
			document.documentElement.style.paddingRight = this.scrollbarWidth + 'px'
		} else {
			document.documentElement.classList.remove( 'with-site-menu-open' )
			document.documentElement.style.paddingRight = 0
		}
	}

	handleMenuItemClick = () => {
		this.props.handleCloseMenu()
	}

	handleMenuItemMouseOver = ( e ) => {
		let text = e.currentTarget.getAttribute( 'data-text' ),
			slug = e.currentTarget.getAttribute( 'data-id' )

		this.setState({
			text: text
		})

		if ( slug ) {
			this.props.getPost( slug )
		}
	}

	renderLink( item ) {
		let linkMarkup,
			className = item.type == 'social' ? '-social' : '',
			icon = item.type == 'social' ? (
				<i className={ item.icon_class } aria-hidden="true"></i>
			) : ''

		if ( '/' === item.url ) {
			linkMarkup = (
				<NavLink
					to='/'
					exact
					activeClassName="is-active"
					onClick={ this.handleMenuItemClick }
					onMouseOver={ this.handleMenuItemMouseOver }
					data-text={ item.content }>
					{ item.title }
				</NavLink>
			)
		} else if ( item.url.indexOf( '//' ) > -1 ) {
			linkMarkup = (
				<a
					href={ item.url }
					className={ className } target="_blank"
					onClick={ this.handleMenuItemClick }
					onMouseOver={ this.handleMenuItemMouseOver }
					data-text={ item.content }>
					{ icon }
					{ item.title }
				</a>
			)
		} else {
			linkMarkup = (
				<NavLink
					to={ item.url }
					exact
					activeClassName="is-active"
					onClick={ this.handleMenuItemClick }
					onMouseOver={ this.handleMenuItemMouseOver }
					data-text={ item.content }
					data-id={ item.url }
				>
					{ item.title }
				</NavLink>
			)
		}

		return linkMarkup
	}

	handleFindChurch = ( e ) => {
		e.preventDefault()

		const { translate, openSearch } = this.props

		let searchTerm = translate( 'Adventist Places Near Me' )

		openSearch( searchTerm )
	}

	render() {
		const { translate, menuItems, withSearchResults } = this.props
		const { text } = this.state
		const wrapClass = this.props.menuIsOpen ? 'on-mobile-is-active primary-menu-wrap' : 'primary-menu-wrap'
		var menuItemsMarkup = ''
		var menuClass = '-menu -with-few'

		if ( menuItems && Object.keys( menuItems ).length > 5 ) {
			menuClass = '-menu -with-many'
		}

		const shareOnFbText = translate( 'Share on {{strong}}Facebook{{/strong}}', {
			components: {
				strong: <strong />
			}
		} )

		if ( menuItems && Object.keys( menuItems ).length ) {
			menuItemsMarkup = Object.keys( menuItems )
				.map( ( key ) => {
					// Top level:

					let e = menuItems[ key ],
						childrenMarkup = '',
						linkMarkup = this.renderLink( e )

					if ( e.children && Object.keys( e.children ).length ) {
						// Children:
						var hasText = false

						let childrenItemsMarkup = Object.keys( e.children )
							.map( ( key ) => {
								let childLinkMarkup = this.renderLink( e.children[ key ] )

								if ( e.children[ key ].content ) {
									hasText = true
								}

								return (
									<li key={ key }>
										{ childLinkMarkup }
									</li>
								)
							})

						let dropdownClass = hasText ? '-dropdown -with-text' : '-dropdown'

						childrenMarkup = (
							<div className={ dropdownClass }>
								<div className="-info">{ text }</div>

								<ul>
									{ childrenItemsMarkup }
								</ul>
							</div>
						)
					}

					return (
						<li key={ key }>
							{ linkMarkup }
							{ childrenMarkup }
						</li>
					)
				})
		}

		return (
			<div className={ wrapClass }>
				<div className="primary-menu">
					<ul className={ menuClass }>
						{ menuItemsMarkup }

						<li><a href="#" onClick={ this.handleFindChurch }>{ translate( 'Find a Church' ) }</a></li>
					</ul>

					<Search />

					{ withSearchResults &&
						<SearchResults />
					}
				</div>

				<LocaleSelect />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuIsOpen: state.site.menuIsOpen,
		menuItems: state.site.menuItems,
		page: state.page.selected,
		locale: state.site.locale,
		searchIsOpen: state.search.isOpen
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleCloseMenu() {
			dispatch( closeMenu() )
		},

		getMenuData() {
			dispatch( getMenuData() )
		},

		openSearch( searchTerm ) {
			let searchArgs = {
				allowMapOverride: true,
				blockUI: true
			}

			dispatch( openSearch() )
			dispatch( setAllowMapOverride( true ) )
			dispatch( searchAction( searchTerm ) )
			dispatch( getSearchData( searchTerm, searchArgs ) )
		},

		getPost: ( slug ) => {
			dispatch( getPageData( slug, 'page', false, true ) )
		}
	}
}

export default localize(
	connect( mapStateToProps, mapDispatchToProps, null, { pure: false } )( Menu )
)



// WEBPACK FOOTER //
// ./components/menu/menu.jsx